import { Flex, Image, Link } from "@chakra-ui/react"

import thesisLogo from "#/assets/by-thesis.svg"
import discordLogo from "#/assets/discord-logo.svg"
import xLogo from "#/assets/x-logo.svg"
import { links } from "#/shared/constants"

import FooterSocialLink from "./FooterSocialLink"

export default function BaseFooter() {
  return (
    <Flex h="100%" w="100%" justifyContent="space-between">
      <Flex alignItems="center" pl={9} pr={2}>
        <Link href={links.THESIS} target="_blank">
          <Image src={thesisLogo} />
        </Link>
      </Flex>
      <Flex pr={10} alignItems="center" justifyContent="flex-end" gap={7}>
        <FooterSocialLink href={links.X} icon={xLogo} />
        <FooterSocialLink href={links.DISCORD} icon={discordLogo} />
      </Flex>
    </Flex>
  )
}
